module.exports = __webpack_public_path__ + "static/pubg-24f73b940c0760b963bcaf3e76092ec7.png";